import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const num = (v) => {
  const n = Number(v ?? 0);
  return Number.isFinite(n) ? n : 0;
};
const sum = (arr, key) => arr.reduce((acc, it) => acc + num(it?.[key]), 0);
const fmt = (v) => (v ?? v === 0 ? v : "0");

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const renderTableByLevel = () => {
    switch (currentLevel) {
      /* ===================== NATIONAL (group by Kab/Kota) ===================== */
      case UserLevel.National.toLowerCase(): {
        const totals = reportsData?.length
          ? {
              total_jumlah_puskesmas: sum(
                reportsData,
                "total_jumlah_puskesmas"
              ),
              jumlah_puskesmas_melakukan_irs: sum(
                reportsData,
                "jumlah_puskesmas_melakukan_irs"
              ),
              total_target_sasaran_rumah_irs: sum(
                reportsData,
                "total_target_sasaran_rumah_irs"
              ),
              jumlah_rumah_disemprot_irs: sum(
                reportsData,
                "jumlah_rumah_disemprot_irs"
              ),
              jumlah_puskesmas_melakukan_kelambu_massal: sum(
                reportsData,
                "jumlah_puskesmas_melakukan_kelambu_massal"
              ),
              total_target_sasaran_kelambu_massal: sum(
                reportsData,
                "total_target_sasaran_kelambu_massal"
              ),
              jumlah_kelambu_massal_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_massal_terdistribusi"
              ),
              jumlah_puskesmas_melakukan_kelambu_massal_fokus: sum(
                reportsData,
                "jumlah_puskesmas_melakukan_kelambu_massal_fokus"
              ),
              total_target_sasaran_kelambu_massal_fokus: sum(
                reportsData,
                "total_target_sasaran_kelambu_massal_fokus"
              ),
              jumlah_kelambu_massal_fokus_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_massal_fokus_terdistribusi"
              ),
              jumlah_puskesmas_melakukan_kelambu_pe: sum(
                reportsData,
                "jumlah_puskesmas_melakukan_kelambu_pe"
              ),
              jumlah_kelambu_pe_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_pe_terdistribusi"
              ),
              jumlah_desa_melakukan_kelambu_klb: sum(
                reportsData,
                "jumlah_desa_melakukan_kelambu_klb"
              ),
              jumlah_kelambu_klb_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_klb_terdistribusi"
              ),
            }
          : null;

        return (
          <>
            <thead>
              <tr>
                <th rowSpan={2}>No.</th>
                <th rowSpan={2}>Nama provinsi</th>
                <th rowSpan={2}>Nama kabupaten/kota</th>
                <th rowSpan={2}>Total jumlah puskesmas</th>
                <th colSpan={3}>IRS</th>
                <th colSpan={3}>Kelambu massal</th>
                <th colSpan={3}>Kelambu massal fokus</th>
                <th rowSpan={2}>
                  Total jumlah puskesmas yang mendistribusikan kelambu PE
                </th>
                <th rowSpan={2}>Jumlah kelambu PE terdistribusi</th>
                <th rowSpan={2}>
                  Total jumlah puskesmas yang mendistribusikan kelambu
                  KLB/bencana
                </th>
                <th rowSpan={2}>Jumlah kelambu KLB/bencana terdistribusi</th>
              </tr>
              <tr>
                <th>Total jumlah puskesmas yang melakukan IRS</th>
                <th>Total target sasaran rumah</th>
                <th>Jumlah rumah yang disemprot</th>
                <th>
                  Total jumlah puskesmas yang mendistribusikan kelambu massal
                </th>
                <th>Total target sasaran kelambu massal</th>
                <th>Jumlah kelambu massal terdistribusi</th>
                <th>
                  Total jumlah puskesmas yang mendistribusikan kelambu massal
                  fokus
                </th>
                <th>Total target sasaran kelambu massal fokus</th>
                <th>Jumlah kelambu massal fokus terdistribusi</th>
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{fmt(item?.nama_provinsi)}</td>
                    <td>{fmt(item?.nama_kabupaten_kota)}</td>
                    <td>{fmt(item?.total_jumlah_puskesmas)}</td>
                    <td>{fmt(item?.jumlah_puskesmas_melakukan_irs)}</td>
                    <td>{fmt(item?.total_target_sasaran_rumah_irs)}</td>
                    <td>{fmt(item?.jumlah_rumah_disemprot_irs)}</td>
                    <td>
                      {fmt(item?.jumlah_puskesmas_melakukan_kelambu_massal)}
                    </td>
                    <td>{fmt(item?.total_target_sasaran_kelambu_massal)}</td>
                    <td>{fmt(item?.jumlah_kelambu_massal_terdistribusi)}</td>
                    <td>
                      {fmt(
                        item?.jumlah_puskesmas_melakukan_kelambu_massal_fokus
                      )}
                    </td>
                    <td>
                      {fmt(item?.total_target_sasaran_kelambu_massal_fokus)}
                    </td>
                    <td>
                      {fmt(item?.jumlah_kelambu_massal_fokus_terdistribusi)}
                    </td>
                    <td>{fmt(item?.jumlah_puskesmas_melakukan_kelambu_pe)}</td>
                    <td>{fmt(item?.jumlah_kelambu_pe_terdistribusi)}</td>
                    <td>{fmt(item?.jumlah_desa_melakukan_kelambu_klb)}</td>
                    <td>{fmt(item?.jumlah_kelambu_klb_terdistribusi)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>
                    <div className="alert alert-danger">Tidak ada data</div>
                  </td>
                </tr>
              )}
            </tbody>
            {totals && (
              <tfoot>
                <tr style={{ fontWeight: 600, backgroundColor: "#d3d3d3ff" }}>
                  <td colSpan={3} style={{ textAlign: "right" }}>
                    Total
                  </td>
                  <td>{totals.total_jumlah_puskesmas}</td>
                  <td>{totals.jumlah_puskesmas_melakukan_irs}</td>
                  <td>{totals.total_target_sasaran_rumah_irs}</td>
                  <td>{totals.jumlah_rumah_disemprot_irs}</td>
                  <td>{totals.jumlah_puskesmas_melakukan_kelambu_massal}</td>
                  <td>{totals.total_target_sasaran_kelambu_massal}</td>
                  <td>{totals.jumlah_kelambu_massal_terdistribusi}</td>
                  <td>
                    {totals.jumlah_puskesmas_melakukan_kelambu_massal_fokus}
                  </td>
                  <td>{totals.total_target_sasaran_kelambu_massal_fokus}</td>
                  <td>{totals.jumlah_kelambu_massal_fokus_terdistribusi}</td>
                  <td>{totals.jumlah_puskesmas_melakukan_kelambu_pe}</td>
                  <td>{totals.jumlah_kelambu_pe_terdistribusi}</td>
                  <td>{totals.jumlah_desa_melakukan_kelambu_klb}</td>
                  <td>{totals.jumlah_kelambu_klb_terdistribusi}</td>
                </tr>
              </tfoot>
            )}
          </>
        );
      }

      /* ===================== PROVINCE (group by Kab/Kota) ===================== */
      case UserLevel.Province.toLowerCase(): {
        const totals = reportsData?.length
          ? {
              total_jumlah_puskesmas: sum(
                reportsData,
                "total_jumlah_puskesmas"
              ),
              jumlah_puskesmas_melakukan_irs: sum(
                reportsData,
                "jumlah_puskesmas_melakukan_irs"
              ),
              total_target_sasaran_rumah_irs: sum(
                reportsData,
                "total_target_sasaran_rumah_irs"
              ),
              jumlah_rumah_disemprot_irs: sum(
                reportsData,
                "jumlah_rumah_disemprot_irs"
              ),
              jumlah_puskesmas_melakukan_kelambu_massal: sum(
                reportsData,
                "jumlah_puskesmas_melakukan_kelambu_massal"
              ),
              total_target_sasaran_kelambu_massal: sum(
                reportsData,
                "total_target_sasaran_kelambu_massal"
              ),
              jumlah_kelambu_massal_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_massal_terdistribusi"
              ),
              jumlah_puskesmas_melakukan_kelambu_massal_fokus: sum(
                reportsData,
                "jumlah_puskesmas_melakukan_kelambu_massal_fokus"
              ),
              total_target_sasaran_kelambu_massal_fokus: sum(
                reportsData,
                "total_target_sasaran_kelambu_massal_fokus"
              ),
              jumlah_kelambu_massal_fokus_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_massal_fokus_terdistribusi"
              ),
              jumlah_puskesmas_melakukan_kelambu_pe: sum(
                reportsData,
                "jumlah_puskesmas_melakukan_kelambu_pe"
              ),
              jumlah_kelambu_pe_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_pe_terdistribusi"
              ),
              jumlah_desa_melakukan_kelambu_klb: sum(
                reportsData,
                "jumlah_desa_melakukan_kelambu_klb"
              ),
              jumlah_kelambu_klb_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_klb_terdistribusi"
              ),
            }
          : null;

        return (
          <>
            <thead>
              <tr>
                <th rowSpan={2}>No.</th>
                <th rowSpan={2}>Nama kabupaten/kota</th>
                <th rowSpan={2}>Total jumlah puskesmas</th>
                <th colSpan={3}>IRS</th>
                <th colSpan={3}>Kelambu massal</th>
                <th colSpan={3}>Kelambu massal fokus</th>
                <th rowSpan={2}>
                  Jumlah Puskesmas yang melakukan distribusi kelambu PE
                </th>
                <th rowSpan={2}>Jumlah kelambu PE terdistribusi</th>
                <th rowSpan={2}>
                  Jumlah desa yang melakukan distribusi kelambu KLB/bencana
                  terdistribusi
                </th>
                <th rowSpan={2}>Jumlah kelambu KLB/bencana terdistribusi</th>
              </tr>
              <tr>
                <th>Jumlah puskesmas yang melakukan IRS</th>
                <th>Total target sasaran rumah</th>
                <th>Jumlah rumah yang disemprot</th>
                <th>
                  Jumlah puskesmas yang melakukan distribusi kelambu massal
                </th>
                <th>Total target sasaran kelambu massal</th>
                <th>Jumlah kelambu massal terdistribusi</th>
                <th>
                  Jumlah puskesmas yang melakukan distribusi kelambu massal
                  fokus
                </th>
                <th>Total target sasaran kelambu massal fokus</th>
                <th>Jumlah kelambu massal fokus terdistribusi</th>
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{fmt(item?.nama_kabupaten_kota)}</td>
                    <td>{fmt(item?.total_jumlah_puskesmas)}</td>
                    <td>{fmt(item?.jumlah_puskesmas_melakukan_irs)}</td>
                    <td>{fmt(item?.total_target_sasaran_rumah_irs)}</td>
                    <td>{fmt(item?.jumlah_rumah_disemprot_irs)}</td>
                    <td>
                      {fmt(item?.jumlah_puskesmas_melakukan_kelambu_massal)}
                    </td>
                    <td>{fmt(item?.total_target_sasaran_kelambu_massal)}</td>
                    <td>{fmt(item?.jumlah_kelambu_massal_terdistribusi)}</td>
                    <td>
                      {fmt(
                        item?.jumlah_puskesmas_melakukan_kelambu_massal_fokus
                      )}
                    </td>
                    <td>
                      {fmt(item?.total_target_sasaran_kelambu_massal_fokus)}
                    </td>
                    <td>
                      {fmt(item?.jumlah_kelambu_massal_fokus_terdistribusi)}
                    </td>
                    <td>{fmt(item?.jumlah_puskesmas_melakukan_kelambu_pe)}</td>
                    <td>{fmt(item?.jumlah_kelambu_pe_terdistribusi)}</td>
                    <td>{fmt(item?.jumlah_desa_melakukan_kelambu_klb)}</td>
                    <td>{fmt(item?.jumlah_kelambu_klb_terdistribusi)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={16}>
                    <div className="alert alert-danger">Tidak ada data</div>
                  </td>
                </tr>
              )}
            </tbody>
            {totals && (
              <tfoot>
                <tr style={{ fontWeight: 600, backgroundColor: "#d3d3d3ff" }}>
                  <td colSpan={2} style={{ textAlign: "right" }}>
                    Total
                  </td>
                  <td>{totals.total_jumlah_puskesmas}</td>
                  <td>{totals.jumlah_puskesmas_melakukan_irs}</td>
                  <td>{totals.total_target_sasaran_rumah_irs}</td>
                  <td>{totals.jumlah_rumah_disemprot_irs}</td>
                  <td>{totals.jumlah_puskesmas_melakukan_kelambu_massal}</td>
                  <td>{totals.total_target_sasaran_kelambu_massal}</td>
                  <td>{totals.jumlah_kelambu_massal_terdistribusi}</td>
                  <td>
                    {totals.jumlah_puskesmas_melakukan_kelambu_massal_fokus}
                  </td>
                  <td>{totals.total_target_sasaran_kelambu_massal_fokus}</td>
                  <td>{totals.jumlah_kelambu_massal_fokus_terdistribusi}</td>
                  <td>{totals.jumlah_puskesmas_melakukan_kelambu_pe}</td>
                  <td>{totals.jumlah_kelambu_pe_terdistribusi}</td>
                  <td>{totals.jumlah_desa_melakukan_kelambu_klb}</td>
                  <td>{totals.jumlah_kelambu_klb_terdistribusi}</td>
                </tr>
              </tfoot>
            )}
          </>
        );
      }

      /* ===================== DISTRICT (group by Puskesmas) ===================== */
      case UserLevel.District.toLowerCase(): {
        const totals = reportsData?.length
          ? {
              total_jumlah_desa: sum(reportsData, "total_jumlah_desa"),
              jumlah_desa_melakukan_irs: sum(
                reportsData,
                "jumlah_desa_melakukan_irs"
              ),
              total_target_sasaran_rumah_irs: sum(
                reportsData,
                "total_target_sasaran_rumah_irs"
              ),
              jumlah_rumah_disemprot_irs: sum(
                reportsData,
                "jumlah_rumah_disemprot_irs"
              ),
              jumlah_desa_melakukan_kelambu_massal: sum(
                reportsData,
                "jumlah_desa_melakukan_kelambu_massal"
              ),
              total_target_sasaran_kelambu_massal: sum(
                reportsData,
                "total_target_sasaran_kelambu_massal"
              ),
              jumlah_kelambu_massal_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_massal_terdistribusi"
              ),
              jumlah_desa_melakukan_kelambu_massal_fokus: sum(
                reportsData,
                "jumlah_desa_melakukan_kelambu_massal_fokus"
              ),
              total_target_sasaran_kelambu_massal_fokus: sum(
                reportsData,
                "total_target_sasaran_kelambu_massal_fokus"
              ),
              jumlah_kelambu_massal_fokus_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_massal_fokus_terdistribusi"
              ),
              jumlah_desa_melakukan_kelambu_pe: sum(
                reportsData,
                "jumlah_desa_melakukan_kelambu_pe"
              ),
              jumlah_kelambu_pe_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_pe_terdistribusi"
              ),
              jumlah_desa_melakukan_kelambu_klb: sum(
                reportsData,
                "jumlah_desa_melakukan_kelambu_klb"
              ),
              jumlah_kelambu_klb_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_klb_terdistribusi"
              ),
            }
          : null;

        return (
          <>
            <thead>
              <tr>
                <th rowSpan={2}>No.</th>
                <th rowSpan={2}>Nama puskesmas</th>
                <th rowSpan={2}>Total jumlah desa</th>
                <th colSpan={3}>IRS</th>
                <th colSpan={3}>Kelambu massal</th>
                <th colSpan={3}>Kelambu massal fokus</th>
                <th rowSpan={2}>
                  Jumlah desa yang melakukan distribusi kelambu PE
                </th>
                <th rowSpan={2}>Jumlah kelambu PE terdistribusi</th>
                <th rowSpan={2}>
                  Jumlah desa yang melakukan distribusi kelambu KLB/bencana
                  terdistribusi
                </th>
                <th rowSpan={2}>Jumlah kelambu KLB/bencana terdistribusi</th>
              </tr>
              <tr>
                <th>Jumlah desa yang melakukan IRS</th>
                <th>Total target sasaran rumah</th>
                <th>Jumlah rumah yang disemprot</th>
                <th>Jumlah desa yang melakukan distribusi kelambu massal</th>
                <th>Total target sasaran kelambu massal</th>
                <th>Jumlah kelambu massal terdistribusi</th>
                <th>
                  Jumlah desa yang melakukan distribusi kelambu massal fokus
                </th>
                <th>Total target sasaran kelambu massal fokus</th>
                <th>Jumlah kelambu massal fokus terdistribusi</th>
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{fmt(item?.nama_puskesmas)}</td>
                    <td>{fmt(item?.total_jumlah_desa)}</td>
                    <td>{fmt(item?.jumlah_desa_melakukan_irs)}</td>
                    <td>{fmt(item?.total_target_sasaran_rumah_irs)}</td>
                    <td>{fmt(item?.jumlah_rumah_disemprot_irs)}</td>
                    <td>{fmt(item?.jumlah_desa_melakukan_kelambu_massal)}</td>
                    <td>{fmt(item?.total_target_sasaran_kelambu_massal)}</td>
                    <td>{fmt(item?.jumlah_kelambu_massal_terdistribusi)}</td>
                    <td>
                      {fmt(item?.jumlah_desa_melakukan_kelambu_massal_fokus)}
                    </td>
                    <td>
                      {fmt(item?.total_target_sasaran_kelambu_massal_fokus)}
                    </td>
                    <td>
                      {fmt(item?.jumlah_kelambu_massal_fokus_terdistribusi)}
                    </td>
                    <td>{fmt(item?.jumlah_desa_melakukan_kelambu_pe)}</td>
                    <td>{fmt(item?.jumlah_kelambu_pe_terdistribusi)}</td>
                    <td>{fmt(item?.jumlah_desa_melakukan_kelambu_klb)}</td>
                    <td>{fmt(item?.jumlah_kelambu_klb_terdistribusi)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={16}>
                    <div className="alert alert-danger">Tidak ada data</div>
                  </td>
                </tr>
              )}
            </tbody>
            {totals && (
              <tfoot>
                <tr style={{ fontWeight: 600, backgroundColor: "#d3d3d3ff" }}>
                  <td colSpan={2} style={{ textAlign: "right" }}>
                    Total
                  </td>
                  <td>{totals.total_jumlah_desa}</td>
                  <td>{totals.jumlah_desa_melakukan_irs}</td>
                  <td>{totals.total_target_sasaran_rumah_irs}</td>
                  <td>{totals.jumlah_rumah_disemprot_irs}</td>
                  <td>{totals.jumlah_desa_melakukan_kelambu_massal}</td>
                  <td>{totals.total_target_sasaran_kelambu_massal}</td>
                  <td>{totals.jumlah_kelambu_massal_terdistribusi}</td>
                  <td>{totals.jumlah_desa_melakukan_kelambu_massal_fokus}</td>
                  <td>{totals.total_target_sasaran_kelambu_massal_fokus}</td>
                  <td>{totals.jumlah_kelambu_massal_fokus_terdistribusi}</td>
                  <td>{totals.jumlah_desa_melakukan_kelambu_pe}</td>
                  <td>{totals.jumlah_kelambu_pe_terdistribusi}</td>
                  <td>{totals.jumlah_desa_melakukan_kelambu_klb}</td>
                  <td>{totals.jumlah_kelambu_klb_terdistribusi}</td>
                </tr>
              </tfoot>
            )}
          </>
        );
      }

      /* ===================== FASYANKES (group by Desa) ===================== */
      default: {
        const totals = reportsData?.length
          ? {
              total_target_sasaran_rumah_irs: sum(
                reportsData,
                "total_target_sasaran_rumah_irs"
              ),
              jumlah_rumah_disemprot_irs: sum(
                reportsData,
                "jumlah_rumah_disemprot_irs"
              ),
              total_target_sasaran_kelambu_massal: sum(
                reportsData,
                "total_target_sasaran_kelambu_massal"
              ),
              jumlah_kelambu_massal_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_massal_terdistribusi"
              ),
              total_target_sasaran_kelambu_massal_fokus: sum(
                reportsData,
                "total_target_sasaran_kelambu_massal_fokus"
              ),
              jumlah_kelambu_massal_fokus_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_massal_fokus_terdistribusi"
              ),
              jumlah_kelambu_pe_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_pe_terdistribusi"
              ),
              jumlah_kelambu_klb_terdistribusi: sum(
                reportsData,
                "jumlah_kelambu_klb_terdistribusi"
              ),
            }
          : null;

        return (
          <>
            <thead>
              <tr>
                <th rowSpan={2}>No.</th>
                <th rowSpan={2}>Nama desa</th>
                <th colSpan={2}>IRS</th>
                <th colSpan={2}>Kelambu massal</th>
                <th colSpan={2}>Kelambu massal fokus</th>
                <th rowSpan={2}>Jumlah kelambu PE terdistribusi</th>
                <th rowSpan={2}>Jumlah kelambu KLB/bencana terdistribusi</th>
              </tr>
              <tr>
                <th>Target sasaran rumah IRS</th>
                <th>Jumlah rumah yang di semprot</th>
                <th>Target sasaran kelambu massal</th>
                <th>Jumlah kelambu massal terdistribusi</th>
                <th>Target sasaran kelambu massal fokus</th>
                <th>Jumlah kelambu massal fokus terdistribusi</th>
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{fmt(item?.nama_desa)}</td>
                    <td>{fmt(item?.total_target_sasaran_rumah_irs)}</td>
                    <td>{fmt(item?.jumlah_rumah_disemprot_irs)}</td>
                    <td>{fmt(item?.total_target_sasaran_kelambu_massal)}</td>
                    <td>{fmt(item?.jumlah_kelambu_massal_terdistribusi)}</td>
                    <td>
                      {fmt(item?.total_target_sasaran_kelambu_massal_fokus)}
                    </td>
                    <td>
                      {fmt(item?.jumlah_kelambu_massal_fokus_terdistribusi)}
                    </td>
                    <td>{fmt(item?.jumlah_kelambu_pe_terdistribusi)}</td>
                    <td>{fmt(item?.jumlah_kelambu_klb_terdistribusi)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10}>
                    <div className="alert alert-danger">Tidak ada data</div>
                  </td>
                </tr>
              )}
            </tbody>
            {totals && (
              <tfoot>
                <tr style={{ fontWeight: 600, backgroundColor: "#d3d3d3ff" }}>
                  <td colSpan={2} style={{ textAlign: "right" }}>
                    Total
                  </td>
                  <td>{totals.total_target_sasaran_rumah_irs}</td>
                  <td>{totals.jumlah_rumah_disemprot_irs}</td>
                  <td>{totals.total_target_sasaran_kelambu_massal}</td>
                  <td>{totals.jumlah_kelambu_massal_terdistribusi}</td>
                  <td>{totals.total_target_sasaran_kelambu_massal_fokus}</td>
                  <td>{totals.jumlah_kelambu_massal_fokus_terdistribusi}</td>
                  <td>{totals.jumlah_kelambu_pe_terdistribusi}</td>
                  <td>{totals.jumlah_kelambu_klb_terdistribusi}</td>
                </tr>
              </tfoot>
            )}
          </>
        );
      }
    }
  };

  let levelName = "";
  if (currentLevel === "national") {
    levelName = "Nasional";
  } else if (currentLevel === "province") {
    levelName = "Provinsi";
  } else if (currentLevel === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: 0 }}>
              <h3>SISMAL v3, REKAP PENGENDALIAN VEKTOR</h3>
            </th>
          </tr>
        </tbody>
      </table>

      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {periodeName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Tahun
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode?.year}
            </th>
          </tr>
          {reportInfo?.statusPeriode === "monthly" && (
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                Bulan
              </th>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                : {monthConverter(reportInfo?.periode?.month_start)} -{" "}
                {monthConverter(reportInfo?.periode?.month_end)}
              </th>
            </tr>
          )}
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
            </th>
          </tr>
        </tbody>
      </table>

      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
